import { Boilerplate } from "@prisma/client"

import { cn, formatPrice } from "@/lib/utils"

export default function Price({
  boilerplate,
  size = "md",
}: {
  boilerplate: Partial<Boilerplate>
  size?: "sm" | "md"
}) {
  function getSize() {
    if (size === "sm") {
      return "w-fit h-fit text-base px-2 py-0.5"
    } else if (size === "md") {
      return "h-[48px] w-fit text-lg px-4"
    } else {
      return "h-[48px] w-fit text-lg px-4"
    }
  }

  return (
    <div
      className={cn(
        "flex w-fit items-center justify-center gap-1 rounded-md bg-neutral-200 font-medium text-main-black",
        getSize()
      )}
    >
      {boilerplate.free ? (
        <span>FREE</span>
      ) : (
        <>
          <span>{formatPrice(boilerplate.minPrice)}$</span> -{" "}
          <span>{formatPrice(boilerplate.maxPrice)}$</span>
        </>
      )}
    </div>
  )
}
